<template>
    <Dialog v-model:visible="visible_" modal header="Информация по ордеру" @hide="close"
        class="border-none"
        :style="{ width: '32rem' }">
        <div v-if="loading" class="flex flex-column gap-2">
            <Skeleton width="40%" height="1rem" />
            <Skeleton width="100%" height="3rem" />
            <Skeleton width="100%" height="12rem" />
        </div>
        <div v-else-if="order" class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
                <span class="text-xs font-medium">ID ордера</span>
                <div class="flex align-items-center gap-2">
                    <span class="text-sm">{{ order.id }}</span>
                    <Button @click="copy(order.id)" icon="pi pi-copy" text severity="secondary" class="text-xs" size="small"/>
                </div>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-xs font-medium">Статус</span>
                <div>
                    <Tag :value="getStatusTitle(order.status)" class="text-xs" :severity="getStatusSeverity(order.status)"
                        :class="(order.status=='confirmed') ? 'bg-green-500 text-green-100' : ''" />
                </div>
            </div>
            <div v-if="order.amount" class="flex flex-column gap-1">
                <span class="text-xs font-medium">Сумма</span>
                <span class="text-sm">{{ getFormatAmount(order.amount, 'rub') }}</span>
            </div>
            <div v-if="order.payment_url" class="flex flex-column gap-1">
                <span class="text-xs font-medium">Payment URL</span>
                <div class="flex align-items-start gap-2">
                    <a :href="order.payment_url" target="_blank" class="text-sm break-all text-blue-600">{{ order.payment_url }}</a>
                    <Button @click="copy(order.payment_url)" icon="pi pi-copy" text severity="secondary" class="text-xs" size="small"/>
                </div>
            </div>
            <div v-if="order.qr_code" class="flex flex-column gap-1">
                <span class="text-xs font-medium">QR код</span>
                <div class="flex align-items-start gap-2">
                    <div class="surface-50 border-1 surface-border border-round p-2">
                        <div v-html="getQrCodeSvg(order.qr_code)" class="qr-code-box"></div>
                    </div>
                </div>
            </div>
            <div v-if="order.description" class="flex flex-column gap-1">
                <span class="text-xs font-medium">Описание</span>
                <span class="text-sm break-words">{{ order.description }}</span>
            </div>
            <div v-if="order.created_at" class="flex flex-column gap-1">
                <span class="text-xs font-medium">Дата создания</span>
                <span class="text-sm">{{ formatDate(order.created_at) }}</span>
            </div>
        </div>
        <div v-else class="text-sm text-600">
            Данные ордера не найдены.
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    name: 'AdminOrderDetails',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: [Number, String],
            default: null
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            visible_: false,
            loading: false,
            order: null,
        }
    },
    methods: {
        getFormatAmount(value, currency, digits=2) {
            return this.helper.format_amount(value, currency, digits)
        },
        getStatusSeverity(status) {
            return this.helper.getStatusSeverity(status)
        },
        getStatusTitle(status) {
            return this.helper.getStatusTitle(status)
        },
        formatDate(dateStr){
            return this.helper.formatDate(dateStr)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        getQrCodeSvg(value) {
            if (!value || typeof value !== 'string') return ''
            if (!value.includes('<svg')) return ''

            // Разрешаем только SVG-разметку без скриптов и инлайн-обработчиков.
            return value
                .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
                .replace(/\son\w+=("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
                .replace(/javascript:/gi, '')
        },
        async loadOrder() {
            if (!this.orderId) return
            this.loading = true
            try {
                const resp = await this.connect.GetAdminOrder(this.orderId).then(res=>res)
                if (resp && resp.result && resp.data) {
                    this.order = Array.isArray(resp.data) ? resp.data[0] || null : resp.data
                } else {
                    this.order = null
                    const message = (resp && resp.message) ? resp.message : 'Не удалось получить ордер'
                    this.$toast.add({ severity: 'warn', summary: 'Ошибка', detail: message, life: 2500 })
                }
            } catch (e) {
                this.order = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка запроса', life: 1500 })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.visible_ = false
            this.$emit('update:modelValue', false)
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            async handler(v) {
                this.visible_ = v
                if (v) await this.loadOrder()
            }
        },
        async orderId(v) {
            if (this.visible_ && v) await this.loadOrder()
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>

<style scoped>
.qr-code-box {
    width: 200px;
    max-width: 100%;
    max-height: 200px;
    overflow: hidden;
}

.qr-code-box :deep(svg) {
    display: block;
    width: 100%;
    height: auto;
    max-width: 200px;
    max-height: 200px;
}
</style>